module.exports = __webpack_public_path__ + "static/media/user3.1232aff5.png";